module.exports = __webpack_public_path__ + "static/media/21ECLAC18.545419c9.jpg";